import { render, staticRenderFns } from "./extra-details-ticket.vue?vue&type=template&id=0fe48c0e&"
import script from "./extra-details-ticket.vue?vue&type=script&lang=js&"
export * from "./extra-details-ticket.vue?vue&type=script&lang=js&"
import style0 from "./extra-details-ticket.vue?vue&type=style&index=0&id=0fe48c0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports